// @flow

import qs from 'qs'
import { mClient, abroadClient } from 'frame/net/clientFactory'
import { initPageInfo } from './pageInfo'

export function getCmsData ({
  code,
  preview,
  isAbroad,
  fetchPromise
}: {
  code: string,
  preview?: boolean,
  isAbroad?: boolean,
  fetchPromise?: Promise<*>
}): Promise<*> {
  const search: string = window.location.search || ''
  const query = qs.parse(search.substr(1))
  query.code = code
  const publishId = query.publishId

  if (!fetchPromise) {
    let apiClient = mClient
    let url = '/cms/public/specialDetail'
    if (isAbroad) {
      apiClient = abroadClient
      url = '/gbltrade/api/v2/cms/specialDetail2'
    }
    fetchPromise = apiClient.get(url, {
      code,
      preview: preview ? '1' : query.preview,
      publishId
    })
  }

  return fetchPromise.then(cmsData => {
    initPageInfo({ ...cmsData, query })
    return cmsData
  })
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/cmsUtil.js